import React from 'react';
import { flattenPromptChanges, formatChangeValue } from '../types';

interface IPromptChangesDiffProps {
    changes?: Record<string, unknown>;
}

const PromptChangesDiff: React.FC<IPromptChangesDiffProps> = ({ changes }) => {
    const flattened = flattenPromptChanges(changes);

    if (!flattened.length) return null;

    return (
        <div className='rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden'>
            {flattened.map(({ path, from, to }) => (
                <div key={path} className='border-b border-gray-100 dark:border-gray-800 last:border-b-0'>
                    <p className='px-4 py-2 text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-800/60 font-mono'>
                        {path}
                    </p>
                    <div className='flex gap-2 px-4 py-1.5 bg-red-50 dark:bg-red-900/20'>
                        <span className='select-none text-red-500 dark:text-red-400 font-mono'>-</span>
                        <span className='text-sm text-red-700 dark:text-red-300 font-mono whitespace-pre-wrap break-words'>
                            {formatChangeValue(from)}
                        </span>
                    </div>
                    <div className='flex gap-2 px-4 py-1.5 bg-green-50 dark:bg-green-900/20'>
                        <span className='select-none text-green-600 dark:text-green-400 font-mono'>+</span>
                        <span className='text-sm text-green-700 dark:text-green-300 font-mono whitespace-pre-wrap break-words'>
                            {formatChangeValue(to)}
                        </span>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PromptChangesDiff;
